module.exports = __webpack_public_path__ + "img/8@2x.551cad89.png";